
import React from 'react';
import { WandSparkles } from 'lucide-react';
import GradientButtonCentered from '@/components/ui/GradientButtonCentered';
import { FilterOption } from '@/components/ui/FilterDropdown';
import { ImageType } from '../FilterBar/TypeFilter';

interface GenerateFormProps {
  imageDescription: string;
  isGenerating: boolean;
  isImageLoading: boolean;
  selectedType: ImageType | null;
  styleOptions: FilterOption[];
  selectedStyle: string | null;
  influenceOptions: FilterOption[];
  selectedInfluence: string | null;
  colorOptions: FilterOption[];
  backgroundOptions: FilterOption[];
  selectedBackground: string | null;
  environmentOptions: FilterOption[];
  moodOptions: FilterOption[];
  width: string;
  height: string;
  onGenerate: () => void;
}

const GenerateForm: React.FC<GenerateFormProps> = ({ 
  imageDescription,
  isGenerating,
  isImageLoading,
  onGenerate
}) => {
  // Check if the description has at least 1 word
  const wordCount = imageDescription.trim().split(/\s+/).filter(word => word.length > 0).length;
  const hasMinimumWords = wordCount >= 1;
  
  return (
    <div className="flex justify-center mt-6">
      <GradientButtonCentered 
        onClick={onGenerate}
        disabled={isGenerating || isImageLoading || !hasMinimumWords}
        variant="purple"
        icon={<WandSparkles className="h-5 w-5" />}
        isLoading={isGenerating || isImageLoading}
        fullWidth={true}
        testId="generate-image-button"
      >
        {isGenerating ? 'Generating...' : isImageLoading ? 'Loading...' : 'Generate Image'}
      </GradientButtonCentered>
    </div>
  );
};

export default GenerateForm;
